import { createContext } from 'react';
import { Students } from '@/models';

export const ActiveStudentContext = createContext<{
  student: Students | null;
  setStudent: any;
}>({ student: null, setStudent: () => {} }); //using any for user as it's server defined
